export const calculateResponsiveSize = (px) => `${px / 15.2}vw`
export const calculateResponsiveHeight = (px) => `${px / 15.2}vh`